import { useEffect, useState } from 'react';
import { Text } from '../../../../ui';
import {
  KoobButton,
  KoobConfirmationModal,
  KoobDataTable,
  KoobInputCheckbox,
} from '@koob/ui';
import { useTranslation } from 'react-i18next';

export default function DistributionSelected({
  selectedDatasHeadings,
  selectedDatas,
  tabTitle,
  onRemoveSelected,
}) {
  const { t } = useTranslation('toConnectionRequest');
  const [checkedIds, setCheckedIds] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);

  const rows = selectedDatas || [];

  const validCheckedIds = checkedIds.filter((id) =>
    rows.some((row) => row.id === id),
  );

  useEffect(() => {
    if (validCheckedIds.length !== checkedIds.length) {
      setCheckedIds(validCheckedIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  const toggleRow = (id) => {
    setCheckedIds((current) =>
      current.includes(id)
        ? current.filter((checkedId) => checkedId !== id)
        : [...current, id],
    );
  };

  const toggleAll = () => {
    setCheckedIds(
      validCheckedIds.length === rows.length ? [] : rows.map((row) => row.id),
    );
  };

  const handleConfirmRemove = () => {
    onRemoveSelected(validCheckedIds);
    setCheckedIds([]);
    setShowConfirm(false);
  };

  const columns = [
    ...(onRemoveSelected && rows.length > 0
      ? [
          {
            key: '__checked',
            width: '30px',
            label: (
              <KoobInputCheckbox
                checked={validCheckedIds.length === rows.length}
                indeterminate={
                  validCheckedIds.length > 0 &&
                  validCheckedIds.length < rows.length
                }
                onCheckedChange={toggleAll}
              />
            ),
            render: (row) => (
              <KoobInputCheckbox
                checked={validCheckedIds.includes(row.id)}
                onCheckedChange={() => toggleRow(row.id)}
              />
            ),
          },
        ]
      : []),
    ...(selectedDatasHeadings || []).map(({ slug, label, width }) => ({
      key: slug,
      label,
      width,
      render: (row) =>
        row?.[slug]?.render ? row[slug].render() : row?.[slug]?.value,
    })),
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <Text type="h3">
          {t(tabTitle)} ({rows.length})
        </Text>

        {onRemoveSelected && validCheckedIds.length > 0 && (
          <KoobButton
            variant="danger"
            size="sm"
            onClick={() => setShowConfirm(true)}
          >
            {t('removeSelected')} ({validCheckedIds.length})
          </KoobButton>
        )}
      </div>

      <KoobDataTable columns={columns} data={rows} />

      {showConfirm && (
        <KoobConfirmationModal
          open={showConfirm}
          setOpen={setShowConfirm}
          title={t('removeSelectedConfirmTitle')}
          description={t('removeSelectedConfirmDescription', {
            count: validCheckedIds.length,
          })}
          danger
          onConfirm={handleConfirmRemove}
        />
      )}
    </div>
  );
}
